import { Reveal } from "./Reveal";

const photos = [
  { src: "/img/band-1.jpg", pos: "50% 25%" },
  { src: "/img/band-2.jpg", pos: "50% 25%" },
  { src: "/img/band-3.jpg", pos: "40% 30%" },
  { src: "/img/band-4.jpg", pos: "50% 25%" },
];

export const BandGallery = () => (
  <div data-testid="together-band-gallery" className="mt-24 sm:mt-32">
    <Reveal className="grid md:grid-cols-12 gap-6 mb-10 items-end">
      <div className="md:col-span-7">
        <p className="text-xs uppercase tracking-[0.32em] text-[var(--goal10)] mb-4">The Together Band movement</p>
        <h3 className="font-display text-4xl sm:text-5xl leading-[1.02] tracking-tight">
          One band. <em>Seventeen goals.</em> A world of voices.
        </h3>
      </div>
      <p className="md:col-span-5 text-stone-700 leading-relaxed">
        Mimi wears Goal 10 alongside fellow Together Band supporters around the world — each colour a promise to one of the 17 Global Goals.
      </p>
    </Reveal>
    <div data-testid="together-band-feature" className="grid md:grid-cols-12 gap-10 md:gap-14 items-center mb-16 sm:mb-24">
      <Reveal className="md:col-span-6">
        <div className="relative">
          <div className="hidden sm:block absolute -inset-4 border border-[var(--gold-soft)] translate-x-5 translate-y-5" />
          <div className="relative aspect-[4/5] overflow-hidden">
            <img src="/img/band-group.jpg" alt="Mimi Tao with fellow Together Band supporters"
              className="absolute inset-0 h-full w-full object-cover" style={{ objectPosition: "50% 22%" }} />
          </div>
          <span className="absolute top-0 left-0 bg-[var(--goal10)] text-white text-[11px] uppercase tracking-[0.2em] px-4 py-2">Goal 10 · Together</span>
        </div>
      </Reveal>
      <Reveal className="md:col-span-5 md:col-start-8" delay={0.1}>
        <p className="text-xs uppercase tracking-[0.32em] text-[var(--goal10)] mb-6">Side by side</p>
        <p className="font-display text-3xl sm:text-5xl leading-[1.05] tracking-tight">
          Different goals. <em>One promise.</em> Leave no one behind.
        </p>
        <p className="mt-6 text-stone-700 leading-relaxed">
          Standing shoulder to shoulder with fellow Together Band supporters, Mimi wears Goal 10 in pink — the colour of reduced inequalities — while each band around her carries its own Global Goal.
        </p>
      </Reveal>
    </div>
    <Reveal className="mb-4 sm:mb-5">
      <img data-testid="together-band-banner" src="/img/band-banner.jpg" alt="The future is built together — Together Band"
        className="w-full aspect-[1000/440] object-cover" />
    </Reveal>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
      {photos.map((p, i) => (
        <Reveal key={p.src} delay={i * 0.08}>
          <figure data-testid={`together-band-photo-${i}`} className="group relative aspect-[3/4] overflow-hidden">
            <img src={p.src} alt="Together Band supporter" loading="lazy" style={{ objectPosition: p.pos }}
              className="absolute inset-0 h-full w-full object-cover group-hover:scale-[1.04] transition-transform duration-[1400ms] ease-out" />
          </figure>
        </Reveal>
      ))}
    </div>
  </div>
);
